import TopFiltersGroupKam from './TopFiltersGroupKam';
export default TopFiltersGroupKam;
